"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowWhatsNewPopup = exports.canAccessWhatsNew = exports.isMemberGuidePublished = exports.canAccessMemberGuide = exports.mergeMemberFeatureFlags = exports.MemberFeatureFlagsUpdateSchema = exports.DEFAULT_MEMBER_FEATURE_FLAGS = exports.MemberFeatureFlagsSchema = void 0;
var zod_1 = require("zod");
var User_1 = require("../User");
var forumAccess_1 = require("./forumAccess");
exports.MemberFeatureFlagsSchema = zod_1.z.object({
    seaServiceDefinitions: zod_1.z.boolean().default(false),
    howToCertify: zod_1.z.boolean().default(false),
    whatsNew: zod_1.z.boolean().default(false),
    forums: zod_1.z.boolean().default(false),
    modernSeaVerification: zod_1.z.boolean().default(false),
    modernSeaMethodChoice: zod_1.z.boolean().default(false),
});
exports.DEFAULT_MEMBER_FEATURE_FLAGS = {
    seaServiceDefinitions: false,
    howToCertify: false,
    whatsNew: false,
    forums: false,
    modernSeaVerification: false,
    modernSeaMethodChoice: false,
};
exports.MemberFeatureFlagsUpdateSchema = exports.MemberFeatureFlagsSchema;
var mergeMemberFeatureFlags = function (flags) { return ({
    seaServiceDefinitions: typeof (flags === null || flags === void 0 ? void 0 : flags.seaServiceDefinitions) === 'boolean'
        ? flags.seaServiceDefinitions
        : exports.DEFAULT_MEMBER_FEATURE_FLAGS.seaServiceDefinitions,
    howToCertify: typeof (flags === null || flags === void 0 ? void 0 : flags.howToCertify) === 'boolean' ? flags.howToCertify : exports.DEFAULT_MEMBER_FEATURE_FLAGS.howToCertify,
    whatsNew: typeof (flags === null || flags === void 0 ? void 0 : flags.whatsNew) === 'boolean' ? flags.whatsNew : exports.DEFAULT_MEMBER_FEATURE_FLAGS.whatsNew,
    forums: typeof (flags === null || flags === void 0 ? void 0 : flags.forums) === 'boolean' ? flags.forums : exports.DEFAULT_MEMBER_FEATURE_FLAGS.forums,
    modernSeaVerification: typeof (flags === null || flags === void 0 ? void 0 : flags.modernSeaVerification) === 'boolean'
        ? flags.modernSeaVerification
        : exports.DEFAULT_MEMBER_FEATURE_FLAGS.modernSeaVerification,
    modernSeaMethodChoice: typeof (flags === null || flags === void 0 ? void 0 : flags.modernSeaMethodChoice) === 'boolean'
        ? flags.modernSeaMethodChoice
        : exports.DEFAULT_MEMBER_FEATURE_FLAGS.modernSeaMethodChoice,
}); };
exports.mergeMemberFeatureFlags = mergeMemberFeatureFlags;
var canAccessMemberGuide = function (key, role, flags) {
    if (flags === void 0) { flags = exports.DEFAULT_MEMBER_FEATURE_FLAGS; }
    if (key === 'forums')
        return (0, forumAccess_1.canSeeForumsNav)(role, flags);
    return (0, User_1.isAdmin)(role) || flags[key];
};
exports.canAccessMemberGuide = canAccessMemberGuide;
var isMemberGuidePublished = function (key, flags) {
    if (flags === void 0) { flags = exports.DEFAULT_MEMBER_FEATURE_FLAGS; }
    return flags[key];
};
exports.isMemberGuidePublished = isMemberGuidePublished;
var canAccessWhatsNew = function (role, flags) {
    if (flags === void 0) { flags = exports.DEFAULT_MEMBER_FEATURE_FLAGS; }
    return (0, User_1.isAdmin)(role) || flags.whatsNew;
};
exports.canAccessWhatsNew = canAccessWhatsNew;
/** Login popup is a member interrupt. Admins still see the listing. */
var shouldShowWhatsNewPopup = function (role, flags) {
    if (flags === void 0) { flags = exports.DEFAULT_MEMBER_FEATURE_FLAGS; }
    return !(0, User_1.isAdmin)(role) && (0, exports.canAccessWhatsNew)(role, flags);
};
exports.shouldShowWhatsNewPopup = shouldShowWhatsNewPopup;
//# sourceMappingURL=memberFeatureFlags.js.map